import _ from "lodash";


/**
 * Extracts instrument data from transactions array.
 * Used during validation to get instruments for extending with asset info.
 */
export const getPortfolioInstrumentsData = (transactions, clearDisabledByFilter = false) => {
  return (transactions || [])
    .map((instrument) => {
      const data = instrument.hasOwnProperty('data')
        ? instrument.data
        : instrument;
      if (clearDisabledByFilter) {
        delete data.disabledByFilter;
        delete data.disabledByAcceptanceCriterias;
      }
      return data;
    });
};

/**
 * Checks if a portfolio has transactions in any of the given keys.
 */
export const portfolioHasTransactions = (_portfolio, transactionsKeys) => {
  return _.some(transactionsKeys, (key) => !_.isEmpty(_portfolio.transactions[key]));
};
